import { create } from 'zustand';
import type { TerminalMessage } from '@/types';

interface TerminalState {
  messages: TerminalMessage[];
  isConnected: boolean;
  history: string[];

  addMessage: (msg: TerminalMessage) => void;
  sendCommand: (command: string) => void;
  clearMessages: () => void;
  setConnected: (connected: boolean) => void;
}

export const useTerminalStore = create<TerminalState>((set, _get) => ({
  messages: [],
  isConnected: false,
  history: [],

  addMessage: (msg) => {
    set((s) => ({ messages: [...s.messages, msg] }));
  },

  sendCommand: (command) => {
    const msg: TerminalMessage = {
      type: 'input',
      data: command,
      timestamp: Date.now(),
    };
    set((s) => ({
      messages: [...s.messages, msg],
      history: [...s.history, command],
    }));
  },

  clearMessages: () => {
    set({ messages: [] });
  },

  setConnected: (connected) => {
    set({ isConnected: connected });
  },
}));
